export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERROR = "CLEAR_ERROR";

export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";
export const REDIRECT = "REDIRECT";

export const AGENT_CREATE_SUCCESS = "AGENT_CREATE_SUCCESS";
export const AGENT_CREATE_FAIL = "AGENT_CREATE_FAIL";
export const TIMELINE_SUCCESS = "TIMELINE_SUCCESS";

export const LOAN_STATUS_CHANGE_SUCCESS = "LOAN_STATUS_CHANGE_SUCCESS";
export const LOAN_STATUS_CHANGE_FAIL = "LOAN_STATUS_CHANGE_FAIL";

export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_FAIL = "NOTIFICATION_FAIL";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const POP_UP_OPEN = "POP_UP_OPEN";
export const CHANGE_NOTIFICATION_READ_STATUS =
  "CHANGE_NOTIFICATION_READ_STATUS";

export const GET_AGENT = "GET_AGENT";
export const GET_AGENTS = "GET_AGENTS";

export const GET_ORDER = "GET_ORDER";
export const GET_ORDERS = "GET_ORDERS";

export const SETTLEMENT_SUCCESS = "SETTLEMENT_SUCCESS";

export const FILTER_AGENTS_BY_LOAN_STATUS = "FILTER_AGENTS_BY_LOAN_STATUS";

export const GET_LOANS = "GET_LOANS";
export const GET_SETTLEMENTS = "GET_SETTLEMENTS";
